import RegionSelect from 'app/components/region/RegionSelect';
import React, { memo } from 'react';
import { escapeRegExp } from 'app/helpers/helpers';
const filterRegions = (regions, filterValue) => {
  const matchValue = escapeRegExp(filterValue.toLowerCase());
  return regions.filter(region => region.name.toLowerCase().search(matchValue) !== -1);
};
const RegionList = /*#__PURE__*/memo(_ref => {
  let {
    regions,
    filterValue,
    districts,
    openRegion,
    loadDistricts
  } = _ref;
  const filteredRegions = filterRegions(regions, filterValue);
  return /*#__PURE__*/React.createElement(React.Fragment, null, filteredRegions.map(region => /*#__PURE__*/React.createElement(RegionSelect, {
    key: region.slug,
    region: region,
    selectedRegion: openRegion,
    districts: districts,
    loadDistricts: loadDistricts
  })));
});
export default RegionList;